import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayPanelModule } from 'primeng';
import { OverlayPanel } from 'primeng/overlaypanel';
import { IRouteRecommendationAlternateDate } from '../../../interfaces/route-recommendations/route-recommendation-alternate-date';

@Component({
  selector: 'route-day-toggle',
  standalone: true,
  imports: [CommonModule, OverlayPanelModule],
  templateUrl: './route-day-toggle.component.html',
  styleUrls: ['./route-day-toggle.component.scss'],
})
export class RouteDayToggleComponent {
  @Input() variants: IRouteRecommendationAlternateDate[] = [];
  @Input() selectedId: number;

  @Output() variantSelected = new EventEmitter<number>();

  @ViewChild('op') op: OverlayPanel;

  get hasMultiple(): boolean {
    return (this.variants?.length ?? 0) > 1;
  }

  get selected(): IRouteRecommendationAlternateDate | null {
    if (!this.variants?.length) {
      return null;
    }
    return this.variants.find((x) => x.id === this.selectedId) ?? this.variants[0];
  }

  onTriggerClick(event: Event): void {
    if (!this.hasMultiple) {
      return;
    }
    this.op.toggle(event);
  }

  // PrimeNG positions the overlay after onShow, so defer and re-centre it under the toggle.
  centerOverlay(triggerEl: HTMLElement): void {
    setTimeout(() => {
      const container = this.op?.container as HTMLElement | undefined;
      if (!container || !triggerEl) {
        return;
      }
      const triggerRect = triggerEl.getBoundingClientRect();
      const centeredLeft =
        triggerRect.left + triggerRect.width / 2 - container.offsetWidth / 2 + window.scrollX;
      container.style.left = `${Math.max(8, centeredLeft)}px`;
    });
  }

  onSelect(variant: IRouteRecommendationAlternateDate): void {
    this.op?.hide();

    if (variant.id === this.selectedId) {
      return;
    }
    this.variantSelected.emit(variant.id);
  }
}
